<template>
  <el-row class="container_self">
    <h3>Stripe Manager</h3>
    <el-row class="table_parent"></el-row>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods:{

    },
    mounted() {

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/view/StripeManager/index.vue